import React from 'react';

import JSONFormatter from 'json-formatter-js';

import './api-output-example.styl'

class ApiOutputExample extends React.Component {
  constructor(props) {
    super(props);
    this.outputData = new JSONFormatter(props.apiOutput, 7)
  }

  componentDidMount() {
    this.wrapperEl.appendChild(this.outputData.render())
  }

  render() {
    return (
      <div style={{ overflowX: 'scroll', padding: '10px', boxShadow: 'inset 0px 0px 2px 0px rgba(0,0,0,0.29)' }}>
        <div  ref={ wrapperEl => this.wrapperEl = wrapperEl }></div>
      </div>
    );
  }
}

export default ApiOutputExample;



// WEBPACK FOOTER //
// ./src/components/apiOutputExample/ApiOutputExample.js